import { Box, Rating } from '@mui/material';
import React from 'react';
import { theme } from '../../../shared/theme';

export default function GuestReviewScoreHint({
    averageRating,
    reviewCount,
}: {
    averageRating?: number | null;
    reviewCount?: number;
}) {
    if (!reviewCount) return null;

    return (
        <Box
            component='span'
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                color: theme.palette.text.secondary,
                fontSize: 12,
                fontWeight: 700,
                whiteSpace: 'nowrap',
            }}
        >
            <Rating
                value={Number(averageRating || 0)}
                readOnly
                precision={0.1}
                size='small'
                sx={{
                    fontSize: 14,
                    '& .MuiRating-iconFilled': {
                        color: 'secondary.main',
                    },
                }}
            />
            {Number(averageRating || 0).toFixed(1)} · {reviewCount} review
            {reviewCount === 1 ? '' : 's'}
        </Box>
    );
}
